export const USER_ROLE = {
  administrator: "administrator",
  assistente: "assistente",
  entrevistador: "entrevistador",
  facilitador: "facilitador",
  underreview: "underreview"
} as const;

export type UserRole = (typeof USER_ROLE)[keyof typeof USER_ROLE];

export const ROLE_OPTIONS = [
  { id: USER_ROLE.administrator, name: "Administrador" },
  { id: USER_ROLE.assistente, name: "Assistente" },
  { id: USER_ROLE.entrevistador, name: "Entrevistador" },
  { id: USER_ROLE.facilitador, name: "Facilitador" },
  { id: USER_ROLE.underreview, name: "Under Review" }
] as const;

export const ROLE_IDS: UserRole[] = Object.values(USER_ROLE);
